// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchGet } from "../../../fetchers";

import "react-datepicker/dist/react-datepicker.css";

import TableListKaryawanPayroll from "../../../components/tablecard/TableListKaryawanPayroll";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../hrd/karyawan/KaryawanSelector";

const PayrollPage = ({}) => {
  let initialState = {};
  const mutation = useMutation(param=>
    fetchPost("getListKaryawanPayroll", param)
  );

  const [TipeKaryawan, setTipeKaryawan] = useState("");


  const validations = [];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const params = useParams();

  useEffect(() => {
    if (params.id) {
      mutation.mutate({
        id: params.id,
        search: ""
      });
    }
  }, []);

  function searchTipeKaryawanHandler(searchValue) {

    mutation.mutate({
      id: params.id,
      search: searchValue
    });

    setTipeKaryawan(searchValue);
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <TableListKaryawanPayroll
                usingMutation={true}
                mutation={mutation}
                hrd={true}
                primaryID="ID"
                transaksi={true}
                tableData={mutation.data}
                handleSearch={() => {}}
                searchTipeKaryawanHandler={searchTipeKaryawanHandler}
                // searchPlaceholder="Izin"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollPage;
